export enum SlotPackage {
  MOBILE_DETAILS = 'MOBILE_DETAILS',
  MOBILE_DETAILS_ENCORE = 'MOBILE_DETAILS_ENCORE',
  DESKTOP_DETAILS = 'DESKTOP_DETAILS',
  DESKTOP_SEARCH_LEFT = 'DESKTOP_SEARCH_LEFT',
  M_CONTEXTUAL = 'M_CONTEXTUAL',
  D_CONTEXTUAL = 'D_CONTEXTUAL',
  M_CONTEXTUAL_CLASS_1_CPM = 'M_CONTEXTUAL_CLASS_1_CPM',
  D_CONTEXTUAL_CLASS_1_CPM = 'D_CONTEXTUAL_CLASS_1_CPM',
  ILM_CLASS_1 = 'ILM_CLASS_1',
  PPP_CLASS_1 = 'PPP_CLASS_1',
  WP_CLASS_1 = 'WP_CLASS_1',
  WD2_TARGETED_CLASS_1 = 'WD2_TARGETED_CLASS_1',
  ROS_DSP_UNGUARANTEED = 'ROS_DSP_UNGUARANTEED',
  STAR_PACKAGE = 'STAR_PACKAGE',
  SEARCH_BTF_DSP = 'SEARCH_BTF_DSP',
  HQP_CLASS_1 = 'HQP_CLASS_1',
  HQP_ILM_DSP = 'HQP_ILM_DSP',
  GATEWAY = 'GATEWAY',
  MTHANKYOU = 'MTHANKYOU',
  MOBILE_HQP_SOV = 'MOBILE_HQP_SOV',
}
